import { Controller } from "@hotwired/stimulus"

// Makes a free-text "other" field mutually exclusive with a set of single-select
// chips (radios): typing in "other" clears the selected chip, and picking a chip
// clears "other". Used on the style step, where the visitor picks one chip OR
// describes their own — but a radio can't be un-picked natively.
export default class extends Controller {
  static targets = ["other", "option"]

  // On input in the "other" field: if it has content, deselect every chip.
  syncFromOther() {
    if (this.otherTarget.value.trim() !== "") {
      this.optionTargets.forEach((option) => {
        option.checked = false
      })
    }
  }

  // On selecting a chip: clear the "other" field.
  syncFromOption() {
    this.otherTarget.value = ""
  }
}
